/* eslint-disable array-callback-return */
/* eslint-disable import/no-anonymous-default-export */
import isEmpty from 'lodash/isEmpty'
import toNumber from 'lodash/toNumber'
import split from 'lodash/split'
import isUndefined from 'lodash/isUndefined'
import toString from 'lodash/toString'

// Addons 2024-05-19
const host_divk = process.env.REACT_APP_DIVISION_K || ''

export default ({
  divisionlogin='E',
  orderItems
}) => {
  console.log(`2024-05-19 :: calculateFinalOrderTotal.js ==> divisionlogin ==> `,divisionlogin)
  console.log(`2024-05-19 :: calculateFinalOrderTotal.js ==> host_divk ==> `,host_divk)

  let priceTotal= 0.00
  let priceTotalWithVat= 0.00
  let priceTotalWithOutVat = 0.00
  let priceNet= 0.00
  let vat = 0.00

  if (!isEmpty(orderItems)) {
    orderItems.map(product => {
      priceTotal = parseFloat(product.price) + parseFloat(priceTotal)
  
      if (product.vatcode === 'Y') {
        priceTotalWithVat = parseFloat(product.price) + parseFloat(priceTotalWithVat)
      } else if (product.vatcode === 'N') {
        priceTotalWithOutVat = parseFloat(product.price) + parseFloat(priceTotalWithOutVat)
      }
    })
  
    // priceNet = (priceTotalWithVat * 1.07) + priceTotalWithOutVat
    
    // let checkDecimal = split(toString(priceNet), '.')
    // if (!isUndefined(checkDecimal[1])) {
    //   let decimalPrevious = toString(checkDecimal[1]).substring(2, 3)
    //   let decimaFinalCheck = toString(checkDecimal[1]).substring(3, 5)
    //   console.log(`checkDecimal[1] => ${checkDecimal[1]}`)
    //   console.log(`decimalPrevious => ${decimalPrevious}`)
    //   console.log(`decimaFinalCheck => ${decimaFinalCheck}`)
    //   if (decimaFinalCheck === '99' && parseFloat(decimalPrevious) <= 4) priceNet = priceNet + 0.01
    // }
  }

  vat = parseFloat((priceTotalWithVat * 1.07)) - parseFloat(priceTotalWithVat)
        console.log(` calculateFinalOrderTotal.js : vat 1 : `, vat)

  if(divisionlogin === host_divk){
    console.log(`2024-05-19 :: round vat header in case div.K`)
    vat = Math.round(10000 * parseFloat(vat))/10000
          console.log(` calculateFinalOrderTotal.js : vat 2 : `, vat)

    vat = Math.round(100 * parseFloat(vat))/100
          console.log(` calculateFinalOrderTotal.js : vat 3 : `, vat)
  }
  
  let checkDecimal = split(toString(vat), '.')
  if (!isUndefined(checkDecimal[1])) {
    let decimalPrevious = toString(checkDecimal[1]).substring(2, 3)
    let decimaFinalCheck = toString(checkDecimal[1]).substring(3, 5)
    if (decimaFinalCheck === '99' && parseFloat(decimalPrevious) === 4) vat = vat + 0.01
  }

  priceNet = (priceTotalWithVat + toNumber(vat.toFixed(2))) + priceTotalWithOutVat

  return {
    priceTotal: toNumber(priceTotal),
    priceTotalWithVat: toNumber(priceTotalWithVat),
    priceTotalWithOutVat: toNumber(priceTotalWithOutVat),
    priceNet: toNumber(priceNet.toFixed(2)),
    vat: toNumber(vat.toFixed(2))
  }
}